import ExceptionExamHomePage from '../components/exception-exam.home-page';
import React from 'react';

const ExamTab = () => {
  return (
    <div>
      <div style={{ flex: '0.5' }}>
        <ExceptionExamHomePage />
      </div>
    </div>
  );
};

export default ExamTab;
